import { subCompanyOwnerStatusApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Owner-status drives the compliance gate for the EARNED pillar + comp-plan chip
// (DEV-3636). A 403/404/error must NOT trigger the global forbidden page-reload
// loop and must degrade to NOT owner — the reducer keeps its non-owner initial
// state on any failure, so the sensitive zones stay hidden until #895 deploys.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_OWNER_STATUS_ACTION_TYPE = createNamedActions(
  'commandCenterOwnerStatus',
  {
    SET_OWNER_STATUS: 'SET_OWNER_STATUS',
  },
);

export const getCommandCenterOwnerStatusAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await subCompanyOwnerStatusApi.getOwnerStatus({
    config: SKIP_FORBIDDEN_CONFIG,
  });

  return dispatch({
    type: COMMAND_CENTER_OWNER_STATUS_ACTION_TYPE.SET_OWNER_STATUS,
    payload: {
      isOwner: data?.isOwner === true,
      ownershipPercentage: data?.ownershipPercentage ?? null,
    },
  });
});
